import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, PasswordInput, PasswordValidationTypography, toast } from '@livable/saas-react-components';
import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Paper, Button } from '@mui/material';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
// import SocialConnectBlock from 'src/components/settings/SocialConnectBlock';
import TwoFactorAuth from 'src/components/settings/TwoFactorAuth';
import { PASSWORD_REQUIRED_ERROR, PASSWORD_RULES_ERROR } from 'src/utils/formValidation/SignUp';
import { updatePasswordInitialValues, resetPasswordSetSchema } from 'src/utils/formValidation/UpdatePassword';
import useStyles from './styles';
import { useStore } from 'src/stores';
export const SignInDetailsTab = observer(() => {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const formik = useFormik({
    initialValues: updatePasswordInitialValues,
    validationSchema: resetPasswordSetSchema,
    onSubmit: async values => {
      const updatePassword = async () => {
        const resp = await store.account.updatePasswordAsync.run(beforeSubmitDataValidation({
          oldPassword: values.oldPassword,
          password: values.newPassword
        }));
        return resp;
      };
      updatePassword().then(resp => {
        if (resp && resp.isSuccessful) {
          formik.resetForm();
          toast('success', {
            body: [t('profile_settings.pass_changed')]
          });
        }
      });
    }
  });
  const getProfile = async () => {
    const resp = await store.account.getProfileAsync.run();
    return resp;
  };
  useEffect(() => {
    setIsLoading(true);
    getProfile().finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const connectedSocials = ['google', 'linkedin'];

  return /*#__PURE__*/React.createElement("div", {
    className: classes.tabWrapper
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.paperBody
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('general.change_password')), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    isInvalid: formik.errors.newPassword === PASSWORD_REQUIRED_ERROR || formik.values.newPassword.trim().length < 8,
    isValidated: formik.touched.newPassword,
    title: t('errors.password_validation_length')
  }), /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    isInvalid: formik.errors.newPassword === PASSWORD_REQUIRED_ERROR || formik.errors.newPassword === PASSWORD_RULES_ERROR,
    isValidated: formik.touched.newPassword,
    title: t('errors.password_validation_chars')
  }), /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    isInvalid: !!formik.errors.repNewPassword,
    isValidated: formik.touched.repNewPassword,
    title: t('errors.password_validation_match')
  }), /*#__PURE__*/React.createElement(PasswordValidationTypography, {
    isValidated: formik.touched.newPassword,
    title: t('profile_settings.pass_rule_three')
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    id: "oldPassword",
    label: t('profile_settings.enter_old_password'),
    error: formik.touched.oldPassword && !!formik.errors.oldPassword,
    name: "oldPassword",
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: formik.handleChange,
    value: formik.values.oldPassword
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    error: formik.touched.newPassword && !!formik.errors.newPassword,
    id: "newPassword",
    label: t('profile_settings.new_password'),
    name: "newPassword",
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: formik.handleChange,
    value: formik.values.newPassword
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    error: formik.touched.repNewPassword && !!formik.errors.repNewPassword,
    id: "repNewPassword",
    label: t('profile_settings.repeat_new_password'),
    name: "repNewPassword",
    onBlur: e => {
      if (e.target.value) formik.handleBlur(e);
    },
    onChange: formik.handleChange,
    value: formik.values.repNewPassword
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.pageFooter
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !formik.isValid || !Object.keys(formik.touched).length || store.account.updatePasswordAsync.inProgress,
    type: "submit",
    variant: "priority",
    'custom-attribute': '733-personal-details-page'
  }, t('buttons.save_changes'))))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Paper, null, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(TwoFactorAuth, null)) : /*#__PURE__*/React.createElement(TwoFactorAuth, null))));
});